import axios from 'axios'

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken')
    if (token) config.headers = { Authorization: token }
    return config
  },
  (error) => Promise.reject(error),
)

axios.interceptors.response.use(
  (response) => {
    if (!response.data.error) return response
  },
  (error) => {
    // when any Api return "Unauthorized" error then reloading the page and clearing localStorage and sessionStorage
    if (error.response.status === 401 && error.response.data.error === 'Unauthorized') {
      localStorage.clear()
      sessionStorage.clear()
      window.location.reload()
    }
    return Promise.reject(error)
  },
)

export const axiosInstance = axios

export { userServices } from './user-service'
export { opportunityServices } from './opportunity-service'
export { investorServices } from './investor-service'
export { kycServices } from './kyc-service'
export { investmentServices } from './investment-service'
export { homeServices } from './home-service'
export { orderServices } from './orders-service'
export { documentServices } from './document-service'
export { withdrawalServices } from './withdrawal-service'
export { queriesServices } from './queries-service'
export { investorOpportunityTermsServices } from './investor-opportunity-terms-service'
export { transactionServices } from './transaction-service'
export { newsletterServices } from './newsletter-service'
export { campaignServices } from './campaign-service'
export { comingSoonAdminServices } from './coming-soon-admin-service'
export { adminTeamServices } from './admin-team-service'
export { opportunityQuestionsServices } from './opportunity-questions-service'
export { secondaryMarketServices } from './secondary-market-service'
export { walletAdminServices } from './wallet-service'
export { manualEntryServices } from './manual-entry-service'
export { opportunityInterestServices } from './opportunity-interest-service'
export { investmentLimitRequestServices } from './investment-limit-request-service'
export { tradingAdminServices } from './trading-service'
